import * as React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={190}
      height={190}
      viewBox="0 0 190 190"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G opacity={0.25} fill="#E40046">
        <Path
          opacity={0.45}
          d="M12.083 76.667c0-9.852 8.567-17.84 19.135-17.84h3.991c-1.867-1.506-3.05-3.73-3.05-6.212 0-4.538 3.946-8.217 8.814-8.217h13.285c-1.344-1.078-2.198-2.672-2.198-4.455 0-3.247 2.823-5.879 6.306-5.879h33.358c3.483 0 6.306 2.632 6.306 5.88 0 3.246-2.823 5.878-6.306 5.878h-12.49c-2.325 1.48-3.853 3.969-3.853 6.792 0 2.483 1.183 4.707 3.05 6.213h20.54c10.569 0 19.136 7.987 19.136 17.84 0 9.852-8.567 17.839-19.135 17.839h27.213c4.867 0 8.814 3.68 8.814 8.217 0 4.538-3.946 8.217-8.814 8.217h11.088c12.115 0 22.171 8.188 24.167 18.951h3.883c7.554 0 13.677 5.708 13.677 12.751v1.292c0 7.042-6.123 12.751-13.677 12.751H36.616c-13.548 0-24.533-10.24-24.533-22.872s10.984-22.872 24.533-22.872h42.95c-4.869 0-8.815-3.679-8.815-8.217s3.946-8.217 8.814-8.217H31.218c-10.568 0-19.135-7.987-19.135-17.84zM109.597 45.823c-3.164 0-5.73-2.632-5.73-5.879 0-3.247 2.565-5.879 5.73-5.879 3.164 0 5.729 2.632 5.729 5.88 0 3.246-2.565 5.878-5.729 5.878z"
        />
      </G>
      <Path
        opacity={0.15}
        d="M95.54 160.879c45.854 0 83.024-1.761 83.024-3.934 0-2.172-37.17-3.934-83.023-3.934-45.853 0-83.023 1.762-83.023 3.934 0 2.173 37.17 3.934 83.023 3.934z"
        fill="#231F20"
      />
      <Path
        d="M20.237 150.57c.26-.19.788.037 2.502-.677 2.5-1.041 3.477-6.423 3.477-6.423-3.805-.476-3.564 5.006-5.037 5.944-.665.423-.978.833-1.121 1.156h.178z"
        fill="#66E8C4"
      />
      <Path
        d="M25.036 145.073c-.782 1.595-1.706 3.947-3.264 4.697a3.629 3.629 0 00-.99.68c.375-.047.968-.145 1.958-.557 2.5-1.041 3.477-6.423 3.477-6.423s-.398.008-1.18 1.603z"
        fill="#3FD2C5"
      />
      <Path
        d="M18.632 150.57h.412c.268-.57.355-1.642-.541-3.608-1.66-3.64-2.497-8.361-1.34-9.749 0 0-3.958 2.821-3.058 5.755.845 2.754 5.097 4.588 4.527 7.602z"
        fill="#35BFE6"
      />
      <Path
        d="M18.8 150.57h.244c.269-.57.355-1.641-.541-3.608-1.66-3.64-2.497-8.361-1.34-9.749 0 0-2.612 2.905-1.621 5.686.978 2.747 3.994 4.177 3.259 7.67l-.001.001z"
        fill="#0A88D2"
      />
      <Path
        d="M14.724 149.031c1.506.614 2.15 1.022 2.57 1.539h.53c-.396-1.195-.632-2.474-1.56-3.44-1.054-1.097-5.114-2.904-5.253-3.113-.14-.21 1.678 4.186 3.712 5.015l.001-.001z"
        fill="#49D3D5"
      />
      <Path
        d="M17.359 150.232c.03.096.077.212.131.338h.333c-.396-1.196-.63-2.474-1.56-3.44-1.053-1.097-5.113-2.903-5.252-3.113 0 0 1.97 2.472 4.162 3.601 1.57.808 1.985 2.004 2.185 2.615v-.001z"
        fill="#0FA1B8"
      />
      <Path
        d="M19.775 148.843a5.68 5.68 0 01-.386 1.726h.288c.99-1.277 2.51-3.754 2.225-6.647-.416-4.227-.869-9.526-.869-9.526s-5.565 4.219-2.827 8.898c1.366 2.333 1.665 4.194 1.57 5.549z"
        fill="#66E8C7"
      />
      <Path
        d="M20.057 141.045c.564 3.503.572 7.426-.328 9.085.163-.116.34-.238.518-.362.906-1.38 1.887-3.473 1.654-5.845-.417-4.227-.87-9.526-.87-9.526s-1.71 2.089-.975 6.649v-.001z"
        fill="#3FD2C5"
      />
      <Path
        d="M23.046 150.312h-6.333a.905.905 0 00-.891 1.06l.809 4.661a1.403 1.403 0 001.378 1.141h3.741c.674 0 1.253-.479 1.379-1.141l.809-4.661a.905.905 0 00-.892-1.06z"
        fill="#CADBF9"
      />
      <Path
        d="M23.95 151.248a.905.905 0 00-.903-.936h-6.334a.904.904 0 00-.903.936h8.14z"
        fill="#A1B7EB"
      />
      <Path
        d="M23.047 150.312h-1.762c.561 0 .987.506.891 1.06l-.809 4.661a1.403 1.403 0 01-1.378 1.141h1.762c.673 0 1.252-.479 1.378-1.141l.809-4.661a.905.905 0 00-.891-1.06z"
        fill="#A1B7EB"
      />
      <Path
        d="M157.905 152.504c.261-.19.788.038 2.502-.677 2.501-1.041 3.477-6.423 3.477-6.423-3.805-.476-3.564 5.007-5.037 5.944-.665.423-.978.834-1.121 1.156h.179z"
        fill="#66E8C4"
      />
      <Path
        d="M162.705 147.007c-.782 1.595-1.707 3.947-3.265 4.697-.434.21-.753.447-.99.68.376-.047.969-.144 1.958-.557 2.501-1.041 3.477-6.423 3.477-6.423s-.397.008-1.18 1.603z"
        fill="#3FD2C5"
      />
      <Path
        d="M156.301 152.504h.412c.268-.57.354-1.641-.542-3.608-1.659-3.64-2.496-8.36-1.34-9.749 0 0-3.958 2.821-3.058 5.755.845 2.754 5.098 4.588 4.528 7.602z"
        fill="#35BFE6"
      />
      <Path
        d="M156.468 152.504h.245c.268-.57.354-1.64-.542-3.608-1.659-3.64-2.496-8.36-1.34-9.749 0 0-2.612 2.905-1.621 5.686.979 2.747 3.995 4.177 3.259 7.67l-.001.001z"
        fill="#0A88D2"
      />
      <Path
        d="M152.392 150.965c1.506.614 2.15 1.022 2.57 1.539h.529c-.395-1.195-.631-2.474-1.56-3.44-1.054-1.097-5.114-2.904-5.253-3.113-.139-.21 1.677 4.186 3.713 5.015l.001-.001z"
        fill="#49D3D5"
      />
      <Path
        d="M155.027 152.166c.031.096.077.212.132.338h.333c-.396-1.195-.631-2.474-1.56-3.44-1.054-1.097-5.114-2.904-5.253-3.113 0 0 1.971 2.472 4.163 3.601 1.569.808 1.985 2.004 2.184 2.615l.001-.001z"
        fill="#0FA1B8"
      />
      <Path
        d="M157.444 150.778a5.675 5.675 0 01-.387 1.726h.289c.989-1.277 2.509-3.754 2.225-6.647-.416-4.227-.869-9.526-.869-9.526s-5.565 4.219-2.827 8.898c1.365 2.334 1.664 4.195 1.569 5.549z"
        fill="#66E8C7"
      />
      <Path
        d="M157.725 142.979c.564 3.504.572 7.426-.328 9.086.165-.117.34-.239.519-.362.906-1.381 1.886-3.474 1.653-5.847-.416-4.227-.869-9.526-.869-9.526s-1.71 2.089-.976 6.649h.001z"
        fill="#3FD2C5"
      />
      <Path
        d="M160.715 152.247h-6.335a.905.905 0 00-.891 1.06l.809 4.661a1.403 1.403 0 001.378 1.141h3.742c.673 0 1.252-.479 1.378-1.141l.809-4.661a.905.905 0 00-.891-1.06h.001z"
        fill="#CADBF9"
      />
      <Path
        d="M161.618 153.182a.905.905 0 00-.903-.936h-6.335a.904.904 0 00-.903.936h8.141z"
        fill="#A1B7EB"
      />
      <Path
        d="M160.715 152.247h-1.762c.562 0 .988.507.892 1.06l-.809 4.661a1.404 1.404 0 01-1.379 1.141h1.762c.673 0 1.252-.479 1.378-1.141l.809-4.661a.905.905 0 00-.891-1.06z"
        fill="#A1B7EB"
      />
      <Path
        d="M119.591 86.435l.178 1.844s-1.762.77-2.075.404c-.312-.366-.528-.27-.528-.27l-.149-2.332 2.574.354zM127.274 85.87l-.111 1.77-2.294-.117-.272-1.972 2.677.32z"
        fill="#22313B"
      />
      <Path
        d="M115.116 56.997h11.564c.022 1.506.034 4.405-.154 6.3-.263 2.655-.753 9.29-.361 11.264.36 1.814 1.459 9.757 1.663 12.059a.44.44 0 01-.444.475c-1.012.004-2.631.175-2.907-.331-.355-.651-2.99-10.743-3.382-12.718-.392-1.975-1.111-3.609-1.111-3.609s-.263 2.656-.208 4.64l.324 11.698a.481.481 0 01-.53.49c-.922-.085-2.047-.1-2.796-.323 0 0-1.206-7.779-1.643-11.407-.438-3.628-1.119-16.832-.191-18.353a.751.751 0 01.176-.188v.003z"
        fill="#3F4752"
      />
      <Path
        d="M127.827 86.62a.441.441 0 01-.444.475c-.22 0-.501-.001-.809-.01-.522-3.716-2.36-14.32-2.714-16.595-.282-1.82.483-9.133.985-13.494h1.834v.003l.002.133v.014l.003.295v.023l.003.316v.03l.001.162v.789l-.001.37v.043l-.001.17v.022l-.002.193v.036l-.002.165v.038l-.002.194v.028c0 .057-.002.113-.003.17v.045l-.009.394-.001.044-.005.175v.024l-.006.195-.001.042a8.61 8.61 0 00-.007.203l-.007.192v.029c-.004.055-.006.11-.008.164l-.002.046c-.006.126-.011.252-.018.376l-.002.043-.01.163-.001.022-.011.181c0 .013-.002.026-.003.038l-.011.148-.003.036-.013.173-.002.024-.013.147-.004.04c-.005.054-.009.109-.015.163a126.562 126.562 0 00-.437 6.097l-.009.209-.017.414-.014.41c-.058 1.76-.044 3.331.115 4.133.061.308.143.791.239 1.393l.008.054.051.32c.223 1.439.505 3.41.757 5.28.28 2.084.524 4.047.609 5.013zM118.935 63.021c.374 1.313 1.204 7.797 1.204 7.797-.095-.24-.156-.38-.156-.38s-.263 2.655-.208 4.64l.324 11.698a.481.481 0 01-.53.49c-.77-.07-1.647-.122-2.528-.297.63-.129 1.603-.58 1.853-1.11.319-.672-.695-12.888-.695-12.888.609-2.335.735-9.952.735-9.952l.001.002z"
        fill="#2F3740"
      />
      <Path
        d="M127.54 87.721s-2.508-.867-3.119-.536c0 0 .017.626-.285.948-.301.323-2.111 2.255-1.791 2.559.318.304 3.43.527 5.273-.154l-.078-2.818v.001zM119.796 87.888c.106-.012.2.07.203.178l.066 2.368s.288.276-1.396.326c-1.684.05-6.176.18-6.465-.098-.289-.277-.016-.571 1.372-1.182 1.388-.611 2.905-1.654 3.45-2.24 0 0 1.122-.034.866.83 0 0 .26-.007 1.904-.182z"
        fill="#2D313D"
      />
      <Path
        d="M114.939 57.185a.753.753 0 01.176-.188h11.564V57.147l.002.147v.025l.001.123v.007l.005.526v.12c-4.331 1.607-9.582.48-11.95-.292.056-.279.122-.49.2-.617l.002-.001z"
        fill="#2F3740"
      />
      <Path
        d="M115.594 53.023c.088-.322.159-.524.159-.524l10.007.41s.035.204.09.554c-.049.068-.09.12-.09.12-4.465 1.823-7.7 1.824-10.166-.56z"
        fill="#330E00"
      />
      <Path
        d="M127.963 44.514l-1.754 6.444.892 6.02s-7.437 3.121-12.409-.123l.535-13.564 12.736 1.222z"
        fill="#286BCE"
      />
      <Path
        d="M129.427 41.431c-.903-1.648-2.524-2.491-3.412-2.848-2.824-.865-6.707-1.072-9.703.19-1.061.446-2.395 1.427-1.085 4.519l.456 9.516s-.509 1.467-.188 1.778c2.467 2.393 5.705 2.393 10.175.568 0 0 .235-.3.266-.42.164-.647-.382-2.453-.382-2.453l2.499-7.767s1.227-1.672 1.374-3.083z"
        fill="#68A9EA"
      />
      <Path
        d="M114.693 57.038l.386-7.965c1.152 1.354 1.79 2.771 2.412 4.436 2.64-1.37 4.95-3.37 6.681-5.788l-1.954 5.224c1.69-1.982 4.352-7.336 6.042-9.319l-2.052 7.332.892 6.02s-7.437 3.303-12.409.06h.002z"
        fill="#286BCE"
      />
      <Path
        d="M119.388 37.704s-.986-.043-1.165.068c-.179.11-.628 1.405-.718 1.609-.09.204 1.198 1.409 1.198 1.409s-1.064 1.746-1.019 1.886c.044.14 1.93 7.771 1.93 7.771s4.572-6.819 4.665-7.157c.092-.34-.438-2.094-.438-2.094s1.354-.997 1.436-1.215c.083-.218.256-1.608 0-1.785-.156-.108-1.067-.313-1.067-.313l-4.823-.181.001.002z"
        fill="#5696E2"
      />
      <Path
        d="M124.211 38.215l-2.636 6.8c-.97 2.504-2.043-.116-2.043-.116l-.303-7.18c.067-.005.207-.022.274-.026l4.707.522h.001z"
        fill="#F8E8D8"
      />
      <Path
        d="M119.581 40.013c-.281-.066-.294-.945-.294-.945l-.056-1.328.009-.02c.07-.007.2-.023.264-.026l4.338.48c-.016.051.159.413.127.515-.252.74-1.061 1.803-1.224 1.829-.19.03-.675-.526-.741-.706-.1.09-.27.359-.37.449-.053 1.292-.006 2.993.015 4.564l-1.755 4.528c-.055.072-.11.14-.165.208l-.162-3.842 1.467-5.548c-.155-.213-.356-.371-.512-.584-.259.253-.58.426-.942.427l.001-.001z"
        fill="url(#paint0_linear_90_129)"
      />
      <Path
        d="M120.584 38.425c.421.243 1.29.37 1.764.381.701.02.42-.392.654-.454l1.21-3.047-3.053-.353-.01.174-.565 3.299z"
        fill="#D38753"
      />
      <Path
        d="M119.533 44.899l1.466-4.95-.641-.72 1.089-.666.834.768-.775.687s.183 2.293.071 4.995l-1.838 4.743-.205-4.857h-.001z"
        fill="#DE3D73"
      />
      <Path
        d="M123.578 37.02s-1.656 1.586-2.081 1.516c-.425-.069-.647-1.667-.647-1.667s-1.435.64-1.62.85c-.184.211.19 2.077.389 2.178.419.21 1.681-1.197 1.911-1.017.229.18.88 1.383 1.095 1.358.214-.024 1.92-1.706 1.823-2.324-.097-.619-.869-.894-.869-.894h-.001z"
        fill="#F8E8D8"
      />
      <Path
        d="M124.223 34.203s1.248-.12 1.214-1.262c-.033-1.109-1.447-.859-1.732.295-.006.023-.038.024-.043 0-.067-.33-.291-1.335-.602-1.591 0 0 .489-1.65-.666-2.149-1.155-.498-3.907-.537-3.961 1.262-.055 1.8.152 2.352.194 3.187.043.835 1.351 3.304 1.902 3.479.552.175 3.252-1.498 3.669-1.92.417-.422.027-1.3.027-1.3h-.002z"
        fill="#F4BE84"
      />
      <Path
        d="M116.518 28.603s.495.104.795-.077c0 0-.615-1.493-.205-2.118 0 0 .906 1.083 3.604.567s5.147.34 5.828 2.641c.681 2.3-1.02 5.445-2.198 5.647.153-.448-.118-1.059-.118-1.059s1.248-.12 1.214-1.262c-.033-1.109-1.447-.859-1.732.295-.006.023-.038.024-.043 0-.067-.33-.291-1.335-.602-1.591 0 0 .489-1.65-.666-2.149-1.155-.498-3.907-.537-3.961 1.262-.006.184-.008.352-.009.512 0 0-2.069-.692-1.905-2.667l-.002-.001z"
        fill="#221E52"
      />
      <Path
        d="M114.075 156.227l9.24-64.961-1.47-.357-9.24 64.961 1.47.357zM98.442 156.227l9.242-64.961-1.47-.357-9.242 64.961 1.47.357z"
        fill="#96B0D6"
      />
      <Path d="M120.064 105.485H104.26v1.952h15.804v-1.952z" fill="#96B0D6" />
      <Path
        d="M125.106 156.216l1.473-.335-8.698-64.962-1.472.336 8.697 64.961zM141.3 156.216l1.473-.335-8.698-64.962-1.472.336 8.697 64.961z"
        fill="#85A5CC"
      />
      <Path
        d="M134.832 105.485H118.76v1.952h16.072v-1.952zM137.302 123.549h-15.68v1.953h15.68v-1.953zM139.881 141.682H124.05v1.952h15.831v-1.952z"
        fill="#85A5CC"
      />
      <Path
        d="M117.824 123.549h-16.222v1.953h16.222v-1.953zM115.244 141.682H99.363v1.952h15.881v-1.952z"
        fill="#96B0D6"
      />
      <Path d="M105.935 92.87h28.14v-1.95h-27.858l-.282 1.95z" fill="#85A5CC" />
      <Path
        d="M68.835 155.9l51.103.327c2.655.018 4.822-2.097 4.838-4.722l.603-98.458c.016-2.695-2.181-4.893-4.907-4.91l-50.85-.326c-2.726-.017-4.949 2.153-4.965 4.847l-.603 98.459c-.017 2.626 2.124 4.768 4.78 4.785v-.002z"
        fill="#222"
      />
      <Path
        d="M70.168 154.944l49.275.315c2.568.017 4.661-2.04 4.678-4.592l.587-95.958c.016-2.62-2.107-4.757-4.742-4.775l-49.03-.313c-2.636-.017-4.785 2.093-4.8 4.714l-.588 95.959c-.015 2.553 2.053 4.635 4.62 4.652v-.002z"
        fill="#696969"
      />
      <Path
        d="M70.497 59.77l-.537 83.192 49.523.32.538-83.193-49.524-.32z"
        fill="url(#paint1_linear_90_129)"
      />
      <Path
        d="M85.193 54.878l-.01 1.436 19.76.127.01-1.436-19.76-.127zM89.375 152.007l11.677.074a.88.88 0 00.888-.873l.009-1.478a.881.881 0 00-.878-.884l-11.677-.074a.88.88 0 00-.888.872l-.009 1.479a.881.881 0 00.878.884z"
        fill="#fff"
      />
      <Path
        opacity={0.34}
        d="M70.45 65.277l49.108 67.37-.066 10.625-49.523-.314.48-77.681z"
        fill="#fff"
      />
      <Path
        d="M70.483 59.767l-.026 4.127 49.523.32.027-4.127-49.524-.32z"
        fill="#C0DDEE"
      />
      <Path
        d="M110.789 82.224l-3.528 32.795a1.007 1.007 0 01-1 .899h-22.57c-.512 0-.943-.384-1-.893l-3.723-32.8h31.822-.001z"
        fill="#E5C040"
      />
      <Path
        opacity={0.2}
        d="M106.379 114.95l3.473-32.725h.936l-3.528 32.795a1.007 1.007 0 01-1.001.899l-.88-.058c.514 0 .945-.393 1-.91v-.001z"
        fill="#fff"
      />
      <Path
        opacity={0.2}
        d="M88.723 82.224c-1.016.732-1.189 2.791-.878 5.744.509 4.833 2.153 21.433 5.064 27.95H83.69c-.512 0-.943-.384-1-.893l-3.723-32.8h9.756zM94.878 112.337c.83 0 1.503-.502 1.503-1.121V86.542c0-.618-.672-1.12-1.503-1.12-.83 0-1.503.5-1.503 1.12v24.674c0 .618.673 1.121 1.503 1.121z"
        fill="#000"
      />
      <Path
        d="M94.878 112.09a1.1 1.1 0 001.1-1.099V86.77a1.1 1.1 0 10-2.2 0v24.221a1.1 1.1 0 001.1 1.099z"
        fill="#000"
        fillOpacity={0.3}
      />
      <Path
        d="M94.696 111.896c.433 0 .783-.484.783-1.084V86.948c0-.598-.35-1.084-.783-1.084-.433 0-.783.485-.783 1.084v23.864c0 .599.35 1.084.783 1.084z"
        fill="#CBAC3F"
      />
      <Path
        opacity={0.2}
        d="M100.621 112.166c.779.096 1.472-.323 1.548-.935l3-24.433c.075-.613-.496-1.188-1.276-1.282-.779-.096-1.472.323-1.547.935l-3 24.433c-.076.613.495 1.188 1.275 1.282z"
        fill="#000"
      />
      <Path
        d="M100.967 111.991a1.1 1.1 0 001.226-.957l2.952-24.04a1.1 1.1 0 00-2.183-.268l-2.952 24.04a1.1 1.1 0 00.958 1.225h-.001z"
        fill="#000"
        fillOpacity={0.3}
      />
      <Path
        d="M102.961 86.726a1.1 1.1 0 01.552-.823c.537.126.907.623.84 1.162l-2.839 23.116c-.07.579-.617.99-1.22.915a1.222 1.222 0 01-.287-.074 1.178 1.178 0 010-.256l2.952-24.04h.002z"
        fill="#CBAC3F"
      />
      <Path
        opacity={0.2}
        d="M88.788 112.29c-.731.09-1.386-.336-1.462-.951l-3.013-24.535c-.075-.616.457-1.188 1.189-1.277.731-.09 1.386.336 1.462.951l3.013 24.536c.075.615-.457 1.187-1.189 1.276z"
        fill="#000"
      />
      <Path
        d="M88.989 111.991a1.1 1.1 0 01-1.226-.957l-2.951-24.04a1.1 1.1 0 012.182-.268l2.952 24.04a1.1 1.1 0 01-.958 1.225z"
        fill="#000"
        fillOpacity={0.3}
      />
      <Path
        d="M85.733 85.775c.012-.002.023-.005.036-.006a1.1 1.1 0 011.225.957l2.952 24.04a1.1 1.1 0 01-.383.975 1.099 1.099 0 01-1.261-.952l-2.952-24.04c-.048-.383.11-.743.383-.974z"
        fill="#CBAC3F"
      />
      <Path
        opacity={0.2}
        d="M79.238 83.728h31.28c.037 0 .073.005.108.01l-.149 1.382H79.295l-.157-1.384c.033-.004.065-.008.1-.008z"
        fill="#000"
      />
      <Path
        d="M78.825 84.608h32.106a.309.309 0 00.309-.309v-.534a.309.309 0 00-.309-.309H78.825a.309.309 0 00-.309.309v.534c0 .17.138.309.309.309z"
        fill="#FFDE5E"
      />
      <Path
        opacity={0.2}
        d="M110.789 82.224l-.079.737H79.05l-.083-.737h31.822z"
        fill="#000"
      />
      <Path
        d="M77.856 78.533h33.722l-.462 3.804H78.318l-.462-3.804zM90.33 74.86l1.205-.073-.1-1.674a.268.268 0 01.248-.285l5.497-.338a.267.267 0 01.28.252l.101 1.674 1.205-.073-.1-1.674a1.482 1.482 0 00-1.56-1.4l-5.496.338c-.81.05-1.43.759-1.38 1.58l.1 1.674z"
        fill="#E5C040"
      />
      <Path
        d="M80.093 75.622l28.923-2.309a2.353 2.353 0 012.533 2.158l-33.614 2.684a2.353 2.353 0 012.158-2.533z"
        fill="#E5C040"
      />
      <Path
        opacity={0.2}
        d="M77.935 78.155a2.353 2.353 0 012.158-2.533l4.817-.384c-.382.46-1.002 1.38-.938 2.435l-6.037.482zM83.91 78.594c0 .977.506 2.653.873 3.742h-6.465l-.462-3.804h6.058c0 .022-.004.04-.004.062z"
        fill="#000"
      />
      <Path
        opacity={0.1}
        d="M104.452 79.684h4.524a.485.485 0 100-.97h-4.524a.485.485 0 100 .97z"
        fill="#fff"
      />
      <Path d="M111.483 132.027H77.951v3.271h33.532v-3.271z" fill="#FFAEC7" />
      <Path d="M112 132H78v3h34v-3z" fill="#E40046" />
      <Path
        d="M82 128.702v-3.509h1.039c.31 0 .586.069.826.207.24.138.427.335.56.588.13.254.197.545.197.873v.176c0 .333-.066.625-.2.878a1.395 1.395 0 01-.567.582 1.703 1.703 0 01-.844.205H82zm.611-3.017v2.526h.398c.32 0 .566-.1.738-.3.171-.2.258-.487.262-.86v-.194c0-.381-.083-.671-.249-.872-.165-.2-.407-.3-.722-.3h-.427zM86.325 128.75c-.372 0-.673-.117-.904-.35-.232-.234-.347-.545-.347-.934v-.073c0-.26.05-.493.151-.697a1.123 1.123 0 011.032-.65c.356 0 .63.113.825.34.193.226.29.547.29.961v.237h-1.707c.018.216.09.386.216.511a.65.65 0 00.477.188.795.795 0 00.656-.325l.317.301a1.052 1.052 0 01-.42.363c-.174.086-.37.128-.588.128h.002zm-.07-2.233a.496.496 0 00-.39.168c-.1.113-.162.269-.19.471h1.118v-.044c-.013-.196-.065-.344-.157-.444a.488.488 0 00-.381-.151zM89.388 128.702a.888.888 0 01-.068-.243.915.915 0 01-.685.291c-.27 0-.477-.074-.642-.224a.716.716 0 01-.248-.554c0-.278.103-.491.31-.64.206-.148.502-.222.887-.222h.36v-.172a.458.458 0 00-.114-.324c-.076-.081-.19-.121-.346-.121a.514.514 0 00-.328.1.308.308 0 00-.128.254h-.587c0-.143.048-.277.143-.401a.945.945 0 01.387-.292c.164-.071.346-.106.547-.106.306 0 .55.077.732.23.182.153.275.369.28.647v1.176c0 .234.033.422.1.561v.041h-.6v-.001zm-.644-.422a.67.67 0 00.327-.084.558.558 0 00.23-.226v-.492h-.316c-.217 0-.38.038-.49.114a.366.366 0 00-.165.32c0 .113.038.202.113.269.075.067.175.1.3.1v-.001zM91.575 128.283a.532.532 0 00.365-.128.438.438 0 00.154-.316h.553a.857.857 0 01-.151.454c-.096.14-.224.252-.386.334a1.152 1.152 0 01-.527.123c-.365 0-.655-.118-.869-.355-.213-.236-.32-.562-.32-.978v-.06c0-.397.106-.715.318-.953.212-.239.502-.358.87-.358.31 0 .563.09.759.271a.971.971 0 01.308.712h-.553a.539.539 0 00-.154-.369.494.494 0 00-.365-.144.517.517 0 00-.44.206c-.102.137-.155.346-.156.625v.095c0 .282.05.493.153.632.102.139.25.209.443.209h-.002zM93.825 125.46v.634h.46v.434h-.46v1.456c0 .099.02.171.06.215.039.045.11.066.21.066a.966.966 0 00.205-.023v.452a1.447 1.447 0 01-.386.056c-.451 0-.676-.248-.676-.745v-1.478h-.43v-.434h.43v-.634h.586l.001.001zM94.736 125.415c0-.091.029-.166.086-.226.056-.06.139-.09.244-.09.106 0 .189.03.247.09.057.06.087.135.087.226a.3.3 0 01-.087.222c-.059.059-.14.088-.247.088-.105 0-.188-.029-.244-.088a.308.308 0 01-.086-.222zm.623 3.287h-.587v-2.607h.587v2.607zM96.918 127.96l.553-1.865h.606l-.905 2.607h-.51l-.912-2.607h.608l.56 1.865zM99.967 128.702a.888.888 0 01-.067-.243.915.915 0 01-.686.291c-.27 0-.476-.074-.642-.224a.716.716 0 01-.248-.554c0-.278.103-.491.31-.64.207-.148.502-.222.887-.222h.36v-.172a.458.458 0 00-.114-.324c-.075-.081-.19-.121-.345-.121a.514.514 0 00-.328.1.308.308 0 00-.128.254h-.587c0-.143.048-.277.143-.401a.945.945 0 01.387-.292c.163-.071.345-.106.546-.106.306 0 .55.077.732.23.182.153.275.369.28.647v1.176c0 .234.033.422.099.561v.041h-.599v-.001zm-.644-.422a.67.67 0 00.327-.084.558.558 0 00.23-.226v-.492h-.316c-.217 0-.38.038-.49.114a.366.366 0 00-.164.32c0 .113.037.202.112.269.075.067.175.1.3.1v-.001zM101.817 125.46v.634h.461v.434h-.461v1.456c0 .099.019.171.059.215.039.044.11.066.211.066a.969.969 0 00.205-.023v.452a1.448 1.448 0 01-.387.056c-.45 0-.676-.248-.676-.745v-1.478h-.43v-.434h.43v-.634h.587l.001.001zM103.876 128.75c-.372 0-.673-.117-.904-.35-.232-.234-.347-.545-.347-.934v-.073c0-.26.051-.493.151-.697a1.12 1.12 0 011.032-.65c.356 0 .631.113.824.34.194.226.291.547.291.961v.237h-1.707c.018.216.09.386.216.511a.65.65 0 00.477.188.797.797 0 00.657-.325l.316.301a1.056 1.056 0 01-.419.363 1.316 1.316 0 01-.589.128h.002zm-.07-2.233a.496.496 0 00-.39.168.88.88 0 00-.19.471h1.118v-.044c-.012-.196-.065-.344-.156-.444a.49.49 0 00-.382-.151zM105.269 127.379c0-.402.094-.724.28-.967a.895.895 0 01.751-.365c.276 0 .5.096.671.288V125h.587v3.702h-.532l-.028-.27a.867.867 0 01-.703.318.908.908 0 01-.742-.368c-.19-.246-.284-.58-.284-1.003zm.587.05c0 .266.051.473.153.621a.499.499 0 00.436.222.555.555 0 00.526-.32v-1.113a.545.545 0 00-.521-.314.503.503 0 00-.44.225c-.102.15-.154.377-.154.679z"
        fill="#000"
      />
      <Path
        d="M49.447 139.228s.614 11.661 1.023 14.16c0 0-.245.661-1.692 1.084-1.447.423-2.294.845-1.721 1.534 0 0 5.461.132 5.899-.185.437-.318.273-.82-.355-2.01 0 0 .9-13.407.382-14.583h-3.536zM53.938 139.228s.082 3.424 1.147 5.777c1.065 2.354 3.085 7.087 3.085 7.853v1.904s1.202.793 1.83-.556c0 0-.273-2.036-.52-3.622-.245-1.586-1.2-6.452-1.555-7.959-.356-1.506-.437-3.397-.437-3.397h-3.55z"
        fill="#E8B795"
      />
      <Path
        d="M48.655 154.509c-1.37.412-2.155.83-1.598 1.497 0 0 5.461.133 5.899-.184.405-.296.292-.75-.229-1.767-.002 0-2.747 1.231-4.071.454h-.001zM58.171 154.763s-.818.707-.389 1.461c.43.754 2.417.213 2.663-.19.246-.405-.444-1.826-.444-1.826l-1.83.556v-.001z"
        fill="#01153E"
      />
      <Path
        d="M54.59 103.675s1.016-.525 1.789 1.524c.773 2.048.813 5.241.534 6.329 0 0 2.246 2.417.41 3.997 0 0-2.527 2.66-2.695 3.345-.065-.161-1.15-2.115-2.908-2.223-1.759-.108-6.092-4.66-3.78-5.367 0 0-.173.735.616.559.789-.177.291-2.891.3-3.851.009-.96.587-3.327 2.268-4.33 1.68-1.004 3.617-.933 3.466.018v-.001z"
        fill="#1C1715"
      />
      <Path
        d="M51.72 109.993s-.363 1.353-.601 1.533c0 0-.24.623.465 2.386.705 1.763 2.49.779 2.776.297.286-.481.916-1.402.34-2.317 0 0-.787-.572-.376-1.815 0 0-2.478-.5-2.603-.085v.001z"
        fill="#EBA97A"
      />
      <Path
        d="M54.632 110.109s-1.195.927-2.172.569c-.976-.358-1.843-1.303-2.11-2.248-.268-.946.167-2.843.824-3.519.657-.675 3.099-1.119 3.785-.239.686.88.952 4.427-.327 5.437z"
        fill="#FDC596"
      />
      <Path
        d="M56.835 126.845s2.6 1.4 2.742 2.105l-2.865-.916.123-1.189z"
        fill="#34455D"
      />
      <Path
        d="M49.19 127.608s-1.044 7.617-.031 12.471c0 0 7.346.581 8.725-.191 0 0 .46-8.36-.108-12.238l-8.586-.043v.001z"
        fill="#314452"
      />
      <Path
        d="M57.885 139.889s-.013-.721.067-1.447c-.62.322-1.992 1.168-4.085.83-2.844-.458-3.497-6.365-3.163-9.142.124-1.039.475-1.974.865-2.74l-2.379.219s-1.044 7.617-.031 12.471c0 0 7.346.581 8.725-.19v-.001z"
        fill="#153047"
      />
      <Path
        d="M54.299 111.44s-2.137.935-3.172-.132c0 0-4.48 4.487-1.937 16.258 0 0 8.543.441 8.712.471.17.03-.613-2.553-1.612-3.27-.992-.711-6.727-4.014-1.97-13.14.032-.062.027-.097-.022-.187h.001z"
        fill="#F6F6F6"
      />
      <Path
        d="M55.101 127.87c-6.762-1.535-4.671-8.448-4.903-9.834-.191-1.153 1.717-4.965 2.367-6.217-.521.005-1.054-.115-1.438-.51 0 0-4.48 4.487-1.937 16.258 0 0 3.395.175 5.947.312l-.037-.009h.001z"
        fill="#DCE2EA"
      />
      <Path
        d="M54.362 111.413s.561.06 1.33.291c.31.095 2.401.858 2.259 4.182-.154 3.59-.48 6.616.036 7.849.517 1.233 1.695 3.283 1.759 5.494-2.665-2.149-5.887-4.457-7.652-8.165-2.453-5.156 2.269-9.651 2.269-9.651h-.001z"
        fill="#FF77C4"
      />
      <Path
        d="M56.282 111.981c.714.444 1.771 1.509 1.669 3.904-.154 3.59-.48 6.616.036 7.849.517 1.233 1.695 3.283 1.759 5.494 0 0-1.154-3.689-3.033-5.62 0 0 1.509-7.763-.43-11.627z"
        fill="#E55DAA"
      />
      <Path
        d="M61.696 127.558s.34.426.255.689c-.077.236-.046.154-.086.254-.013.034-.035.104-.035.104s-.212.645-.052.784c.161.14.331.041.378-.316.046-.357.628-.389.705.181.078.57.361 1.188.544 1.024.183-.166.031-.626.031-.626s.025-.01.056.11-.02.442.063.402c.084-.042.645-.275.628-1.053-.018-.778-.466-1.09-.629-1.242-.162-.151-.594-.799-.599-1.055 0 0-1.307.31-1.259.745v-.001z"
        fill="#FCC596"
      />
      <Path
        d="M56.086 112.337s-.832 2.523.44 4.768c1.269 2.245 2.671 6.582 3.49 7.94a135.65 135.65 0 011.667 2.855l1.613-.537s-1.946-5.387-2.779-6.528c0 0-1.705-8.843-4.43-8.498h-.001z"
        fill="#FF77C4"
      />
      <Path
        d="M54.583 111.412l-1.895 1.566-.303-1.115 1.52-.429.678-.022zM51.2 111.308l1.112.509-1.051 1.209s-.51-1.237-.06-1.719v.001z"
        fill="#9CD6E2"
      />
      <Path
        d="M38.453 119.21l1.907-.659a.25.25 0 01.313.138l2.347 5.481a.252.252 0 01-.209.35l-2.175.191a.251.251 0 01-.255-.154l-2.078-5.014a.252.252 0 01.15-.334v.001z"
        fill="#1E2B5B"
      />
      <Path
        d="M39.866 120.449a.204.204 0 01.342.131.876.876 0 01-.103.492c-.238.454-.26.973-.152.973.107 0 .411-.973.78-.898.367.076-.39 1.222-.282 1.374.108.152.52-.8.714-.628.194.173-.455 1.169-.39 1.299.065.13.497-.411.54-.217.044.195-.061.585-.713.996 0 0-.975.693-1.451.173-.451-.492-.65-2.442.713-3.695h.002z"
        fill="#FDC596"
      />
      <Path
        d="M44.477 120.394c-.736 1.401-2.547 1.231-2.547 1.231l.888 2.074c2.583.896 4.213-1.333 4.213-1.333 1.688-1.65 2.293-10.558 2.293-10.558-2.683.736-4.112 7.185-4.847 8.585v.001z"
        fill="#E55DAA"
      />
      <Path
        d="M47.686 114.898s.134-.855.424-1.982c.083-.324.299-.708.598-.893.648-.4 1.69-.599 2.492-.715 0 0-2.228 8.489-2.076 14.956.11.569.156 1.061.066 1.302 0 0-.53.209-1.441.819-.836.56.324-4.233.52-5.027-.539-3.084-.899-5.252-.583-8.461v.001z"
        fill="#FF77C4"
      />
      <Path
        d="M55.99 113.144s.98.379 1.537-.377c.556-.755-.378-1.21-.378-1.21s.608.765-.278.861c-.886.096-.892-1.392-.581-2.212.898-2.37.377-3.928-.038-4.777-.416-.849-1.155-1.471-1.155-1.471l-.507-.283-.35.861s.637.974.96 1.873c.323.899.46 2.054-.296 3.542-.757 1.489-.947 2.951 1.086 3.194v-.001z"
        fill="#442B19"
      />
      <Path
        d="M54.239 104.536l.351-.861s1.016-.525 1.789 1.524c.266.703.404 1.548.46 2.398-.347 1.273-1.33 2.741-1.866 3.989-.677 1.574 1.392 1.153 1.392 1.153s-.689 1.167-1.725.268c-1.14-.988-.146-2.618.29-3.472.434-.854.361-2.471-.056-3.391a16.03 16.03 0 01-.635-1.607v-.001z"
        fill="#513826"
      />
      <Path
        d="M54.239 104.536s-2.316-.614-3.48 2.19c-1.163 2.803.507 4.095.214 4.959-.294.865-1.082.989-1.76.1 0 0 .832.537.956-.07.124-.605-1.259-1.493-1.133-3.806.045-.812.176-1.51.328-2.077.356-.835.92-1.675 1.76-2.175 1.68-1.004 3.617-.933 3.466.018l-.351.861z"
        fill="#442B19"
      />
      <Path
        d="M108.083 55.007s.107.858.44 1.133c.3.25.192.167.324.266.046.033.133.106.133.106s.821.675.812 1c-.009.323-.26.337-.65-.098-.39-.436-.948.021-.462.845.485.823.831 1.889.505 1.827-.326-.063-.638-.806-.638-.806s-.031.01.058.195c.089.186.45.571.333.588-.116.016-.85.187-1.593-.863-.742-1.05-.64-1.848-.64-2.188 0-.34-.241-1.571-.486-1.915 0 0 1.485-.71 1.866-.088l-.002-.002z"
        fill="#F9CFA5"
      />
      <Path
        d="M108.422 54.932l-2.352.073.072.756 2.264-.292.016-.537z"
        fill="#fff"
      />
      <Path
        d="M106.04 55.235l2.398-.098c.047-1.153.194-2.572.823-4.033 1.018-2.363 3.248-5.368 8.096-7.934 0 0 1.617-1.327.765-2.873-.628-1.139-2.115-1.474-3.221-.79-3.107 1.918-10.222 7.302-8.861 15.728z"
        fill="#68A9EA"
      />
      <Path
        d="M124.238 57.972s-.661.557-1.093.535c-.389-.02-.254-.008-.418-.027-.056-.005-.171-.011-.171-.011s-1.061-.06-1.274.183c-.213.244-.038.425.544.37.581-.056.681.658-.234.933-.915.276-1.894.824-1.611.999.283.175 1.016-.16 1.016-.16s.018.028-.174.105c-.192.076-.718.114-.644.205.074.09.499.715 1.756.448 1.257-.267 1.725-.922 1.956-1.172.231-.25 1.244-.99 1.657-1.078 0 0-.609-1.529-1.31-1.33z"
        fill="#F4BE84"
      />
      <Path
        d="M124.041 57.687l1.677 1.65-.566.506-1.465-1.752.354-.404z"
        fill="#fff"
      />
      <Path
        d="M125.584 59.526l-1.696-1.7c.748-.879 1.604-2.02 2.133-3.52.857-2.427 1.257-6.147-.561-11.321 0 0-.307-2.212 1.561-2.68 1.196-.299 2.251.545 2.582 1.732.98 3.52 2.695 12.226-4.019 17.489z"
        fill="#68A9EA"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_90_129"
          x1={121.017}
          y1={39.8057}
          x2={117.401}
          y2={49.6856}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#CFD4D8" />
          <Stop offset={1} stopColor="#CFD4D8" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_90_129"
          x1={95.2798}
          y1={59.9329}
          x2={94.6697}
          y2={143.164}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FDFDFD" />
          <Stop offset={0.11} stopColor="#EBF8FD" />
          <Stop offset={0.31} stopColor="#D3F3FE" />
          <Stop offset={0.52} stopColor="#C1EFFE" />
          <Stop offset={0.74} stopColor="#B7ECFE" />
          <Stop offset={1} stopColor="#B4ECFF" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
